import Vue from "vue";
import VueRouter from "vue-router";

import LoginPage from "@/components/users/Login.vue";
// importaciones eliminadas porque ya no se usan
import ProductionView from "@/components/pages/ProductionView.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: LoginPage,
  },
  {
    path: "/production",
    name: "production",
    component: ProductionView,
    meta: { requiresAuth: true },
  },
  {
    path: "/production/zones",
    name: "production-zones",
    component: ProductionView,
    meta: { requiresAuth: true },
  },
  {
    path: "/production/formats",
    name: "production-formats",
    component: ProductionView,
    meta: { requiresAuth: true },
  },
  {
    path: "/production/quantity",
    name: "production-quantity",
    component: ProductionView,
    meta: { requiresAuth: true },
  },
  {
    path: "/production/list",
    name: "production-list",
    component: ProductionView,
    meta: { requiresAuth: true },
  },
  {
    path: "/production/prediction",
    name: "production-prediction",
    component: ProductionView,
    meta: { requiresAuth: true },
  },
  {
    path: "/production/weekly",
    name: "production-weekly",
    component: ProductionView,
    meta: { requiresAuth: true },
  },
  {
    path: "/production/campaign",
    name: "production-campaign",
    component: ProductionView,
    meta: { requiresAuth: true },
  },
  {
    path: "/production/control",
    name: "production-control",
    component: ProductionView,
    meta: { requiresAuth: true },
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  const accessToken = localStorage.getItem("token");
  const isAuthenticated = !!accessToken;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && !isAuthenticated) {
    next({ name: "login" });
    return;
  }

  if (to.name === "login" && isAuthenticated) {
    next({ name: "production" });
    return;
  }

  // Si intenta acceder a rutas antiguas, redirige a la principal
  if (to.path.startsWith("/farmlands")) {
    next({ name: "production" });
    return;
  }

  next();
});

export default router;
